import React from 'react'
import HealthcareBanner from '../Healthcare/HealthcareBanner';
import HealthcareExcellence from '../Healthcare/HealthcareExcellence';
import HealthcareFacility from '../Healthcare/HealthcareFacility';
import HealthcareCounter from '../Healthcare/HealthcareCounter';
import HealthcareSmart from '../Healthcare/HealthcareSmart';
import HealthcarePremise from '../Healthcare/HealthcarePremise';
import HealthcareBrand from '../Healthcare/HealthcareBrand';
import HealthcareBusinesse from '../Healthcare/HealthcareBusinesse';
import HealthcareFaq from '../Healthcare/HealthcareFaq';
import HomeProducts from '../../home/HomeProducts';

export default function Garment({initialData}) {

    const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/commercial-laundry-for-garment-manufacturing",
                name: "Garments"
            }
        ]

    }



    const Banner = {
        buttonText: "Global Markets",
        buttonLink: "/markets",
        title: "Built for Precision Garment  Processing",
        description: "Supershine provides heavy-duty, high-capacity machinery designed for the rigors of garment  manufacturing. From garment dyeing and denim washing to fabric preparation, we empower manufacturers with the technology to achieve superior finishes at scale.",
        image: "/assets/images/textile-banner1.webp"
    };

    const excellenceData = {
        subtitle: "Industrial Manufacturing Standards",
        title: "Advanced Solutions for Modern Garment  Units",
        description1: " Supershine – Garment Division is a Supershine systems, carrying forward a legacy that began in 1990. Supershine systems started with supplying machines for Hospitality sector in 1990. With 35+ years of industry expertise, we have consistently focused on delivering the Best Solutions through a blend of Best Products, Best Service, and Best Relationships. Today, Supershine Garment Solutions is the authorized dealer for global sewing machine, Finishing machines. We meticulously manage every process to ensure a seamless and dependable solution experience for our clients.",
        description2: "We serve garment export houses, fabric processing units, and industrial dye houses. With a focus on high-torque motors, advanced chemical injection, and robust stainless-steel construction, Supershine equipment is the backbone of efficient garment  production lines across the globe.",
        buttonText: "Talk to Our Experts",
        buttonLink: "/contact"
    };


    const facilityData = {
        title: "Why Garment  Professionals <br>  Trust SuperShine",
        items: [
            {
                icon: "/assets/images/textile-icon1.webp",
                heading: " Global-Standard Products",
                description: "We represent world-class industrial laundry brands recognised for precision, durability, and consistent performance. Including globally trusted names like Eastman, Pony, Rotondi, and Milnor, backed by reliable warranty support. No compromises."
            },
            {
                icon: "/assets/images/textile-icon2.webp",
                heading: "Expert After-Sales Service",
                description: "Our team of skilled mechanical and electronic engineers responds fast and resolves most breakdowns within 48 hours of a call, ensuring your production stays on track with minimal disruption. Because when your machines stop, so does everything else."
            },
            {
                icon: "/assets/images/textile-icon3.webp",
                heading: " Trusted Partnerships",
                description: "A family-owned company with over 40 years of legacy, built on trust and honesty. Our founder's values have shaped long-standing customer relationships across the country and earned us an undisputed reputation in the garment manufacturing industry."
            },

            {
                icon: "/assets/images/textile-icon4.webp",
                heading: "Resource Optimization",
                description: "Efficient water and energy usage reduces operational costs while supporting sustainable garment  manufacturing."
            },

            {
                icon: "/assets/images/textile-icon5.webp",
                heading: " Durable Construction",
                description: " Heavy-duty design withstands demanding garment  plant environments and long operating hours."
            },


            {
                icon: "/assets/images/textile-icon6.webp",
                heading: " Scaled Workflow",
                description: " Seamless integration with pre-wash, dyeing, rinsing, and finishing processes enhances overall production flow."
            }
        ]
    };


    const HeathCareCounter = {
        title: "Proven Results In Garment  Care",
        stats: [
            {
                end: 750,
                suffix: "+",
                text: "Garment  Processors <br> Trust Us",
            },
            {
                end: 96,
                suffix: "%",
                text: "Color Fastness Retention <br>  Rate",
            },
            {
                end: 50,
                suffix: "+",
                text: "Fabric Types Processed <br> Successfully",
            },
            {
                prefix: "",
                end: 40,
                suffix: "%",
                text: "Faster Processing With Precision Control",
            },
        ],
    };

    const Fashionsmart = {
        extraClass: "",
        heading: `Sustainable Finishing for a Circular Economy`,
        description: "The garment  industry faces strict environmental regulations. Supershine’s Green-Wash technology focuses on low liquor ratios—using significantly less water and energy per kilogram. We help manufacturers stay compliant with global environmental audits while lowering their operational costs.",
        buttonText: "Learn More",
        buttonLink: "/about",
        altText: "Smart"
    };


    const PremiseData = {
        image: "/assets/images/processing-left-image.webp",
        title: "Own Your Garment  Processing, Elevate Your Quality",
        subtitle: "The Competitive Edge:",
        reasons: [
            "<strong>Batch Integrity: </strong> Ensure every garment in a 500-piece lot receives the exact same mechanical treatment and chemical exposure.",
            "<strong> Reduced Lead Times:</strong>  By integrating high-speed washing and drying in-house, you eliminate external logistics and meet tight shipping deadlines.",
            "<strong> Fabric Versatility: </strong>   From delicate knits to heavy 14oz denim, our machines adapt to the specific tensile requirements of your product line.",
            "<strong> Low Maintenance Costs:</strong>  Designed for the factory floor, our equipment features easy-access components and heavy-duty bearings for a longer service life.",
            " <strong> Custom Engineering: </strong> We don't just sell machines; we design entire laundry workflows that integrate seamlessly with your existing production floor."
        ],
        buttonText: "Design Your Hotel Solution",
        buttonLink: "/contact"
    };


    const healthcareBrandData = {
        title: "",
        logos: [
            { image: "/assets/images/hospital-logos6.webp", title: "Brand 1" },
            { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
            { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
            { image: "/assets/images/hospital-new-img1.webp", title: "Brand 4" },
            { image: "/assets/images/hospital-new-img2.webp", title: "Brand 5" },
            { image: "/assets/images/hospital-new-img3.webp", title: "Brand 6" },
            { image: "/assets/images/hospital-logos2.webp", title: "Brand 2" },
            { image: "/assets/images/hospital-logos5.webp", title: "Brand 3" },
        ]
    };



    const businessData = {
        title: "Praised By Manufacturers <br/> For Precision.",
        description:
            "Export-ready finishing standards and uniform quality across batches make Supershine the trusted choice for garment manufacturing units.",
        testimonials: [
            {
                rating: 5,
                text:
                    "“Finishing quality directly affects how our garments are perceived by export buyers, and our old pressing equipment was inconsistent across large orders. Supershine's machines have brought a level of uniformity to our finishing process that has noticeably reduced rejection rates during quality checks from international clients”",
                client: "Vivek Agarwal, Production Head, Garment Export Unit",
            },
            {
                rating: 5,
                text:
                    "“Consistency across batches is everything when you're fulfilling bulk export orders with strict specifications. Since installing Supershine's equipment, our finishing line has maintained the same quality standard whether we're processing a hundred pieces or ten thousand. That reliability has strengthened our relationships with overseas buyers considerably.”",
                client: "Shalini Bhardwaj, Quality Manager, Garment Manufacturing Unit",
            },
            {
                rating: 5,
                text:
                    "“Production efficiency in garment manufacturing comes down to how fast finishing can keep pace with stitching output. Supershine's machines have removed what used to be a bottleneck in our process, allowing us to increase order capacity without adding extra finishing staff. The impact on our overall turnaround time has been substantial.”",
                client: "Nitin Khurana, Operations Director, Garment Production Facility",
            },
        ],
    };



    const productData = {
        subtitle: "Recommended Products",
        title: "Precision Equipment <br> For Every Processing Stage",
     
    };

    const faqData = {
        title: "FAQs",
        description: "Find answers to your most searched questions about laundry services for the garment  industry. ",
        buttonText: "Talk to an expert",
        buttonLink: "/contact",
        faqs: [
            {
                question: "Can Supershine systems handle bulk garment  processing?",
                answer: "Yes. Our machines are designed for high-capacity industrial loads, supporting continuous production in garment  and garment manufacturing facilities.",
            },
            {
                question: " How do Supershine systems maintain fabric consistency?",
                answer: "  Through programmable controls and optimized drum engineering, our systems ensure uniform washing, controlled agitation, and repeatable process outcomes.",
            },
            {
                question: "Are Supershine solutions suitable for dyeing and finishing plants?",
                answer: "  Yes. Our equipment supports pre-treatment, post-dye washing, rinsing, and finishing processes commonly used in garment  plants.",
            },

            {
                question: "How do Supershine systems help reduce operational costs?",
                answer: " By optimizing water, energy, and chemical usage, our systems lower utility expenses and reduce production waste.",
            },

            {
                question: " Can the machines be customized for different garment  materials?",
                answer: "Yes. Wash programs can be adjusted to accommodate cotton, polyester blends, denim, knitwear, and specialty fabrics.",
            },

            {
                question: " Does Supershine provide technical support and installation?",
                answer: "  Absolutely. We provide complete assistance including consultation, installation, operator training, and after-sales service.",
            },
        ],
    };

    return (
        <>

            <HealthcareBanner data={Banner} breadcrumb={bannerData.breadcrumb} />
            <HealthcareExcellence data={excellenceData} />
            <HealthcareFacility data={facilityData} />
            <HealthcareCounter data={HeathCareCounter} />
            <HealthcareSmart data={Fashionsmart} />
            <HealthcarePremise data={PremiseData} />
            <HealthcareBrand data={healthcareBrandData} />
            <HealthcareBusinesse data={businessData} />
            <HomeProducts data={productData} extraClass="healthcare-product" initialData={initialData}/>
            <HealthcareFaq data={faqData} />
        </>
    )
}








